export var authenticateSelector = function (state) {
    return state.authenticate;
};
//# sourceMappingURL=authenticate.js.map